/**
 * ⟦C8 · A-120⟧ **Le compte à rebours RÉEL du manager** — la toute première mécanique temps
 * réel du jeu, et elle vit ICI, jamais dans `shared/` : le moteur reste pur et au tour par
 * tour (CLAUDE.md), aucune horloge réelle, aucun `setTimeout` ne le traverse. « C'est un vrai
 * minuteur, sinon ça n'a pas de sens — le temps simulé ne bouge pas pendant que la pop-up est
 * là » (décision de Mathieu, C8 §1).
 *
 * Pur du point de vue du composant qui l'utilise : ce module ne connaît ni React, ni l'état
 * de jeu, ni le moteur — juste `setInterval`/`clearInterval`. `EvenementModal` l'appelle dans
 * un `useEffect` et annule le minuteur (la fonction rendue) à la moindre interaction du
 * joueur : « il a la main, toujours » (C8 §4).
 */

/** ⟦C8 §1 ✎⟧ La durée du compte à rebours — « 45-60 s » dans le brief, fixée ici à 45. */
export const DUREE_MINUTEUR_MANAGER_S = 45;

export interface OptionsMinuteurManager {
  /** Durée totale, en secondes. Défaut : `DUREE_MINUTEUR_MANAGER_S`. */
  dureeS?: number;
  /** Appelé à chaque seconde écoulée, avec le nombre de secondes RESTANTES (dureeS → 0). */
  onTick: (secondesRestantes: number) => void;
  /** Appelé une seule fois, quand le compte à rebours atteint 0. */
  onExpire: () => void;
}

/**
 * Démarre le compte à rebours. Rend une fonction d'ANNULATION — à appeler à la moindre
 * interaction du joueur avec la modale (un clic, une touche) : « il a la main, toujours »
 * (C8 §4). L'appeler après expiration (ou plusieurs fois) est sans effet.
 */
export function demarrerMinuteurManager(options: OptionsMinuteurManager): () => void {
  const dureeS = options.dureeS ?? DUREE_MINUTEUR_MANAGER_S;
  let ecoulees = 0;
  options.onTick(dureeS);
  const id = setInterval(() => {
    ecoulees += 1;
    const restantes = dureeS - ecoulees;
    if (restantes <= 0) {
      clearInterval(id);
      options.onTick(0);
      options.onExpire();
      return;
    }
    options.onTick(restantes);
  }, 1000);
  return () => clearInterval(id);
}
